import { render, staticRenderFns } from "./QuotationItemForm.vue?vue&type=template&id=df671c6e&"
import script from "./QuotationItemForm.vue?vue&type=script&lang=js&"
export * from "./QuotationItemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports